<app-filter-panel [numberOfResults]="numberOfResults" [activeFilterCount]="activeFilterCount" (apply)="onApply()"
    (cancel)="onCancel()">

    <div class="row g-0 m-0 borderb">
        <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
            <span class="item-name">{{ "STATUS" | translate }}</span>
        </div>
        <div class="col-md-12 d-flex flex-column justify-content-start custom-left-padding pe-3 pb-3">
            <div class="row-md-12 switch-container d-flex pb-3" *ngFor="let status of statuses">
                <div class="col-auto d-flex align-items-center">
                    <label class="switch" [for]="'checkbox-fw-status-' + status">
                        <input type="checkbox" [id]="'checkbox-fw-status-' + status"
                            [checked]="draftStatuses.includes(status)" (change)="toggleStatus(status)" />
                        <span class="slider round"></span>
                    </label>
                </div>
                <div class="col ps-3 d-flex justify-content-start">
                    <label [for]="'checkbox-fw-status-' + status">{{ statusTranslationKey(status) | translate }}</label>
                </div>
            </div>
        </div>
    </div>

    <div class="row g-0 m-0 borderb">
        <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
            <span class="item-name">{{ "DEVICESETUP_ASSETTYPE" | translate }}</span>
        </div>
        <div class="col-md-12">
            <app-multi-select-dropdown-search [selected]="draftAssetTypeIds" [fetchItems]="fetchAssetTypes"
                placeholder="SEARCHBY_ASSETTYPE" (listEmitted)="onAssetTypeListReceived($event)">
            </app-multi-select-dropdown-search>
        </div>
    </div>

    <div class="row g-0 m-0 borderb">
        <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
            <span class="item-name">{{ "DEVICESETUP_AREA" | translate }}</span>
        </div>
        <div class="col-md-12">
            <app-multi-select-dropdown-search [selected]="draftAreas" [fetchItems]="fetchAreas"
                placeholder="AREA_SEARCHBY" (listEmitted)="onAreaListReceived($event)">
            </app-multi-select-dropdown-search>
        </div>
    </div>

    <div class="row g-0 m-0 borderb">
        <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
            <span class="item-name">{{ "REGION" | translate }}</span>
        </div>
        <div class="col-md-12">
            <app-multi-select-dropdown-search [selected]="draftRegions" [fetchItems]="fetchRegions"
                placeholder="REGION_SEARCHBY" (listEmitted)="onRegionListReceived($event)">
            </app-multi-select-dropdown-search>
        </div>
    </div>

</app-filter-panel>
